export default "__VITE_ASSET__1c60f7b9__"